module.exports = __webpack_public_path__ + "img/_transparent.7a7b6ef0.jpg";